export default {
  apiKey: 'AIzaSyCmGMphMe3qXMmsQpDq6CH-IBp2HfFsW_s',
  authDomain: 'notarygpt.firebaseapp.com',
  projectId: 'notarygpt',
  storageBucket: 'notarygpt.appspot.com',
  messagingSenderId: '612871768976',
  appId: '1:612871768976:web:2c1bea64ad0f0eb20a8115',
  measurementId: 'G-D4639CXEF5'
}
